import Vue from 'vue'
import Vuex from 'vuex'
import detail from './modules/detail'
import list from './modules/list'
import config from './modules/config'
import productDetail from './modules/productDetail'
import stones from './modules/stones'
import buildYourJewel from './modules/buildYourJewel'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    detail,
    list,
    config,
    productDetail,
    stones,
    buildYourJewel
  }
})
